<template>
  <div class="table-pagination">
    <a-pagination
      style="float: right"
      v-model:current="data.next"
      v-model:pageSize="data.size"
      show-quick-jumper
      show-less-items
      :total="total"
      @change="handleChange"
      v-bind="$attrs"
    />
  </div>
</template>

<script setup lang="ts">
import { reactive, watch } from "vue";

interface PageData {
  next: Number;
  size: Number;
  total: Number;
}

interface PageProps {
  getData: Function;
  total: Number;
  pageSizes?: any;
  size: Number;
}

const props = withDefaults(defineProps<PageProps>(), {
  pageSizes: [10, 20, 50, 100, 200, 300, 400]
})

const data = reactive<PageData>({
  next: 1,
  size: 20,
  total: 0,
})

const handleChange = (next, size) => {
  props.getData({ next, size });
}

watch(
  props, () => {
    data.size = props.size ? props.size : data.size
  },
  { immediate:true, deep:true }
)
</script>

<style lang="scss" scoped>
.table-pagination {
  margin: 20px 0;
  height: 40px;
}
</style>
